import { render, staticRenderFns } from "./StarredMessages.vue?vue&type=template&id=0a998a76&scoped=true&"
import script from "./StarredMessages.vue?vue&type=script&lang=js&"
export * from "./StarredMessages.vue?vue&type=script&lang=js&"
import style0 from "./StarredMessages.vue?vue&type=style&index=0&id=0a998a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a998a76",
  null
  
)

export default component.exports